var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10 -5 430 215",
    width: 430,
    height: 215,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "utahGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#00A0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#C850C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF1493"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "greenGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ADFF2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#32CD32"
  })), /*#__PURE__*/React.createElement("style", null, "\n      @import url('https://fonts.googleapis.com/css2?family=Russo+One&amp;display=swap');\n      .logo-text {\n        font-family: 'Russo One', 'Impact', 'Arial Black', sans-serif;\n        font-weight: 900;\n        font-style: italic;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-6, 260, 100) skewX(-15)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 75,
    className: "logo-text",
    fontSize: 62,
    fill: "none",
    stroke: "black",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }, "LIGHTIN UP"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 75,
    className: "logo-text",
    fontSize: 62,
    fill: "none",
    stroke: "#FF1493",
    strokeWidth: 6,
    strokeLinejoin: "round"
  }, "LIGHTIN UP"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 75,
    className: "logo-text",
    fontSize: 62,
    fill: "url(#greenGrad)"
  }, "LIGHTIN UP"), /*#__PURE__*/React.createElement("text", {
    x: 246,
    y: 170,
    className: "logo-text",
    fontSize: 110,
    textAnchor: "middle",
    fill: "none",
    stroke: "black",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }, "UTAH"), /*#__PURE__*/React.createElement("text", {
    x: 246,
    y: 170,
    className: "logo-text",
    fontSize: 110,
    textAnchor: "middle",
    fill: "url(#utahGrad)"
  }, "UTAH"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.31e735cdb79851cc369db0d6ed9f3ac9.svg";
export { ForwardRef as ReactComponent };